const scope = 'loop/Home/Filters';

// 

export const GET_CITY = `${scope}/GET_CITY`;
export const GET_CITY_SUCCESS = `${scope}/GET_CITY_SUCCESS`;
export const GET_CITY_ERROR = `${scope}/GET_CITY_ERROR`;

export const GET_COMPANIES = `${scope}/GET_COMPANIES`;
export const GET_COMPANIES_SUCCESS = `${scope}/GET_COMPANIES_SUCCESS`;
export const GET_COMPANIES_ERROR = `${scope}/GET_COMPANIES_ERROR`;

export const GET_POSITIONS = `${scope}/GET_POSITIONS`;
export const GET_POSITIONS_SUCCESS = `${scope}/GET_POSITIONS_SUCCESS`;
export const GET_POSITIONS_ERROR = `${scope}/GET_POSITIONS_ERROR`;

export const GET_POSITION = `${scope}/GET_POSITION`;
export const GET_POSITION_SUCCESS = `${scope}/GET_POSITION_SUCCESS`;
export const GET_POSITION_ERROR = `${scope}/GET_POSITION_ERROR`;


export const GET_COMPANY = `${scope}/GET_COMPANY`;
export const GET_COMPANY_SUCCESS = `${scope}/GET_COMPANY_SUCCESS`;
export const GET_COMPANY_ERROR = `${scope}/GET_COMPANY_ERROR`;



export const CLEAR_CITY = `${scope}/CLEAR_CITY`;
export const CLEAR_POSITION = `${scope}/CLEAR_POSITION`;
export const CLEAR_COMPANY = `${scope}/CLEAR_COMPANY`;

export const GET_CITIES = `${scope}/GET_CITIES`;
export const GET_CITIES_SUCCESS = `${scope}/GET_CITIES_SUCCESS`;
export const GET_CITIES_ERROR = `${scope}/GET_CITIES_ERROR`;

export const CLEAR_ALL = `${scope}/CLEAR_ALL`;

